var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "boxed"
};
const _hoisted_2 = {
    key: 0,
    class: "form",
    style: { "margin-bottom": "32px" }
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("label", null, "Name", -1 /* HOISTED */);
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "list-detail-drawer__detail-section__footer" };
const _hoisted_6 = { class: "right" };
import { ref, watch, toRef, computed } from "vue";
import { ElMessageBox } from "element-plus";
import Button from "src/shared/v-components/ui/Button.vue";
import ExtoleDrawer from "src/shared/v-components/ui/ExtoleDrawer.vue";
import ComponentVariableList from "src/shared/v-components/component-variable/list/ComponentVariableList.vue";
import { createComponentMutableForEditing } from "src/shared/store/component-mutable/service/createComponentMutableForEditing";
import { notify } from "src/shared/v-components/ui/notification/notification-service";
import { useComponentMutable } from "src/shared/store/component-mutable/composables/useComponentMutable";
import { saveComponent } from "src/shared/store/component/service/saveComponent";
import { useComponentStoreV2 } from "src/shared/store/component";
import { getErrorMessage } from "src/shared/store/common/Exception";
import Strings from "src/shared/Strings";
import { useCampaignStore } from "src/shared/store/campaign";
import { useBuiltComponent } from "src/shared/store/component-built/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditComponentDrawer',
    props: {
        componentId: {},
        shouldPublish: { type: Boolean, default: false }
    },
    emits: ["closed", "update:modelValue", "saved", "archived"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const componentStore = useComponentStoreV2();
        const campaignStore = useCampaignStore();
        const isShown = ref(true);
        const isArchiving = ref(false);
        const isSaving = ref(false);
        const componentMutableKey = ref(undefined);
        const setComponentMutableKey = (componentId) => __awaiter(this, void 0, void 0, function* () {
            const { componentMutableKey: newComponentMutableKey } = yield createComponentMutableForEditing({
                componentId,
            });
            componentMutableKey.value = newComponentMutableKey;
        });
        const { builtComponent } = useBuiltComponent(toRef(props, "componentId"));
        const componentMutable = computed(() => {
            const { componentMutable: newComponentMutable } = useComponentMutable(toRef(componentMutableKey.value));
            return newComponentMutable.value;
        });
        const showConfirmation = () => {
            ElMessageBox.confirm("Are you sure you want to archive this component?")
                .then(() => __awaiter(this, void 0, void 0, function* () {
                yield archive();
            }))
                .catch(() => {
                return;
            });
        };
        const componentName = computed({
            get: () => { var _a; return ((_a = componentMutable.value) === null || _a === void 0 ? void 0 : _a.getName()) || ""; },
            set: (value) => {
                if (componentMutable.value) {
                    componentMutable.value.setName(value);
                }
            },
        });
        const save = () => __awaiter(this, void 0, void 0, function* () {
            try {
                isSaving.value = true;
                if (componentMutable.value) {
                    yield saveComponent(componentMutable.value);
                    if (props.shouldPublish) {
                        yield campaignStore.publishDraft(componentMutable.value.campaign_id, {
                            message: null,
                            launch: true,
                        });
                    }
                    notify({
                        type: "success",
                        message: `${Strings.capitalize(componentMutable.value.getName())} has been updated.`,
                    });
                    isShown.value = false;
                    emit("saved");
                }
            }
            catch (error) {
                notify({
                    type: "error",
                    message: getErrorMessage(error),
                });
            }
            finally {
                isSaving.value = false;
                emit("saved");
            }
        });
        const archive = () => __awaiter(this, void 0, void 0, function* () {
            if (componentMutable.value) {
                try {
                    isArchiving.value = true;
                    yield componentStore.deleteComponent(componentMutable.value.campaign_id, componentMutable.value.component_id);
                    emit("archived");
                    notify({
                        type: "success",
                        message: `${Strings.capitalize(componentMutable.value.getName())} has been archived.`,
                    });
                    isShown.value = false;
                }
                catch (error) {
                    notify({
                        type: "error",
                        message: getErrorMessage(error),
                    });
                }
                finally {
                    isArchiving.value = false;
                }
            }
        });
        watch(() => props.componentId, (componentId) => {
            setComponentMutableKey(componentId);
        }, {
            immediate: true,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ExtoleDrawer, {
                modelValue: isShown.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((isShown).value = $event)),
                showClose: false,
                width: "708px",
                onClosed: _cache[2] || (_cache[2] = ($event) => (emit('closed')))
            }, {
                title: _withCtx(() => [
                    (_unref(builtComponent))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("h1", null, "Edit " + _toDisplayString(_unref(Strings).capitalize(_unref(builtComponent).name)), 1 /* TEXT */)
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(Button, {
                                onClick: _withModifiers(showConfirmation, ["prevent"]),
                                level: 'secondary',
                                "is-pending": isArchiving.value
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode("Delete")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["is-pending"]),
                            _createVNode(Button, {
                                onClick: _withModifiers(save, ["prevent"]),
                                "is-pending": isSaving.value
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode("Save")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["is-pending"])
                        ])
                    ])
                ]),
                default: _withCtx(() => [
                    (componentMutable.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _hoisted_3,
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((componentName).value = $event)),
                                type: "text",
                                placeholder: "Name"
                            }, null, 512 /* NEED_PATCH */), [
                                [_vModelText, componentName.value]
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    (componentMutableKey.value && componentMutable.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(ComponentVariableList, {
                                "component-mutable-key": componentMutableKey.value,
                                type: 'STANDARD'
                            }, null, 8 /* PROPS */, ["component-mutable-key"])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
